import { render, staticRenderFns } from "./productItem.vue?vue&type=template&id=e1e836e6&"
import script from "./productItem.vue?vue&type=script&lang=js&"
export * from "./productItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports